import React from 'react';

// Components
import Meta from '../components/meta.js';

class ContactUs extends React.Component {
  render() {
    return (
      <section id="contact-us">
        <Meta
          title="Talk to Our Energy Intelligence Team | Voltaware"
          description="Contact Voltaware to discuss energy intelligence, smart meter data analytics and NILM solutions for utilities, partners and households."
          url="https://voltaware.com/contact-us"
        />

        <section className="contact-us-map">
          <iframe
            allowFullScreen=""
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1265.9468722499626!2d-1.975939130494998!3d50.61051192125323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48730912775c9c25%3A0xd05c4b546dd73217!2sHerston%20Cross%20House%2C%20230%20High%20St%2C%20Swanage%20BH19%202PQ%2C%20UK!5e0!3m2!1sen!2sbr!4v1764782263757!5m2!1sen!2sbr"
            title="Contact us map"
          ></iframe>
        </section>

        <section className="section container" id="contact">
          <div className="col contact-us-contact">
            <h1 className="title">
              <span>Address</span>
            </h1>
            <strong>United Kingdom:</strong>
            <p style={{ margin: 0 }}>
              Herston Cross House, 230 High Street, Swanage, Dorset
            </p>
            <p>BH19 2PQ</p>
            <br />
            <strong>Italy:</strong>
            <p style={{ margin: 0 }}>Voltaware Europe, Corso Monforte</p>
            <p>20122 Milano</p>
            <br />
            <strong>United States:</strong>
            <p style={{ margin: 0 }}>444 Somerville Avenue, Somerville</p>
            <p>MA 02143</p>
            <br />
            <p>
              <a href="mailto:enquiries@voltaware.com">
                enquiries@voltaware.com
              </a>
            </p>
          </div>
        </section>
        <section className="section container">
          <div className="col contact-us-contact">
            <h2 className="title">
              <span>Support</span>
            </h2>
            <p>
              If you did not find what you need on the SUPPORT page, please
              email us at
            </p>
            <p>
              <a href="mailto:support@voltaware.com">support@voltaware.com</a>
            </p>
          </div>
        </section>
        <section className="section container" id="work">
          <div className="col contact-us-contact">
            <h2 className="title">
              <span>Work for us</span>
            </h2>
            <p>
              If you are interested in applying for a position with Voltaware,
              please send your CV and covering letter to{' '}
              <a href="mailto:elena@voltaware.com">elena@voltaware.com</a>,
              indicating which office you will be willing to work for.
            </p>
          </div>
        </section>
      </section>
    );
  }
}

export default ContactUs;
